import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./ui/App";
import { initAds } from "./services/ads";
import "./styles.css";

// Initialize ad networks
// TODO: Replace with your actual AdSense publisher ID
// initAds({
//   network: "adsense",
//   publisherId: "ca-pub-XXXXXXXXXX",
//   enabled: true
// });

// For now, ads are disabled until you configure your publisher ID
initAds({ enabled: false });

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


